/* ============================================================
   ORION CONTACT — turns the routed enquiry form into steps.

   The markup ships complete and submittable. This script is the
   enhancement layer: it collapses the fieldsets into three steps,
   reveals the order-number and callback fields only when they're
   relevant, and blocks "Continue" until the current step validates.
   With JS off nothing here runs and the whole form is simply visible,
   which is why no field is hidden in the Liquid except the two that
   are genuinely conditional.
   ============================================================ */
(() => {
  function setup(form) {
    if (form.dataset.orionReady === '1') return;
    const steps = Array.from(form.querySelectorAll('[data-o-step]'));
    const next = form.querySelector('[data-o-next]');
    const back = form.querySelector('[data-o-back]');
    const submit = form.querySelector('[data-o-submit]');
    const rail = form.querySelector('[data-o-rail]');
    if (steps.length < 2 || !next || !back || !submit) return;

    form.dataset.orionReady = '1';
    let index = 0;

    // ---- conditional fields -------------------------------------------
    const orderField = form.querySelector('[data-o-order-field]');
    const orderInput = orderField && orderField.querySelector('input');

    form.querySelectorAll('[data-o-topic]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!orderField) return;
        const wants = radio.dataset.needsOrder === 'true';
        orderField.hidden = !wants;
        // A hidden-but-present field would still post an empty value and, more
        // to the point, could block submit if it were ever required.
        if (orderInput) orderInput.disabled = !wants;
      });
    });

    const callback = form.querySelector('[data-o-callback]');
    const callbackFields = form.querySelector('[data-o-callback-fields]');
    if (callback && callbackFields) {
      const phone = callbackFields.querySelector('input[type="tel"]');
      const sync = () => {
        callbackFields.hidden = !callback.checked;
        if (phone) {
          phone.required = callback.checked;
          if (callback.checked) phone.focus({ preventScroll: true });
        }
      };
      callback.addEventListener('change', sync);
      sync();
    }

    // ---- stepping ------------------------------------------------------
    if (rail) {
      rail.classList.add('is-live');
      rail.removeAttribute('aria-hidden');
    }

    const paint = () => {
      steps.forEach((step, i) => {
        step.hidden = i !== index;
      });
      back.hidden = index === 0;
      next.hidden = index === steps.length - 1;
      submit.hidden = index !== steps.length - 1;

      if (rail) {
        Array.from(rail.children).forEach((li, i) => {
          li.classList.toggle('is-on', i === index);
          li.classList.toggle('is-done', i < index);
        });
      }
    };

    /* Validate only the step on screen. reportValidity() on the whole form
       would surface errors on fields the visitor hasn't reached yet, and the
       browser refuses to focus a hidden invalid field — the form would look
       frozen with no visible reason. */
    const stepValid = () => {
      const fields = steps[index].querySelectorAll('input, textarea, select');
      for (const field of fields) {
        if (field.disabled || field.offsetParent === null) continue;
        if (!field.checkValidity()) {
          field.reportValidity();
          return false;
        }
      }
      return true;
    };

    next.addEventListener('click', () => {
      if (!stepValid()) return;
      index = Math.min(index + 1, steps.length - 1);
      paint();
      const first = steps[index].querySelector('input:not([type="radio"]), textarea, select');
      if (first) first.focus({ preventScroll: true });
      steps[index].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });

    back.addEventListener('click', () => {
      index = Math.max(index - 1, 0);
      paint();
    });

    // Picking a topic is the whole of step 1, so advance on the choice itself.
    form.querySelectorAll('[data-o-topic]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (index !== 0) return;
        window.setTimeout(() => next.click(), 180);
      });
    });

    // Enter inside a single-line field should advance, not submit early.
    form.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      if (event.target.tagName === 'TEXTAREA') return;
      if (index === steps.length - 1) return;
      event.preventDefault();
      next.click();
    });

    paint();
  }

  const boot = () => document.querySelectorAll('.o-contact__form').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
